import type { ComponentProps } from 'react'

import type { IconNames } from '~/@common/ui/Icon/iconNames.type.ts'

export type Props = {
  name: IconNames
  size?: number
  rotate?: number
} & ComponentProps<'svg'>

export const kind = 'ms__Icon'

export const Icon = ({ name, size = 16, rotate = 0, style, ...props }: Props) => {
  return (
    <svg
      data-component={kind}
      data-track={name}
      width={size}
      height={size}
      style={{ flexShrink: 0, transform: `rotate(${rotate}deg)`, ...style }}
      {...props}
    >
      {/* 배포는 sprite 를 릴리스 폴더에만 올린다 — 루트 절대경로로 두면 버킷 루트의 옛 사본을 가리켜 신규 심볼이 사라진다 */}
      <use xlinkHref={`${import.meta.env.BASE_URL}sprite.svg#${name}`} />
    </svg>
  )
}
